module.exports = __webpack_public_path__ + "img/GAME_RAINWINDOW.008f2843.jpg";